module.exports = __webpack_public_path__ + "img/friends-ukr.98b22b3a.png";